<template>
	<div>
		<div class="fs4 fw7 lh125 mt6 mb2">车辆类型：</div>
		<case-form :schema="schemaVehicle" />

		<div class="fs4 fw7 lh125 mt6 mb2">比赛目的</div>
		<case-form :schema="schemaPurpose" />

		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "您曾参加什么类别的比赛或竞赛？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0typeOfRacingOrCompetitionCN`,
					props: {
						suggest: {
							typeIncludes: `typeOfRacingOrCompetitionCN`
						},
						createOptions: {
							type: `typeOfRacingOrCompetitionCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "如果是短距加速赛，该项赛事的持绩时间是多久？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dragRacingElapsedTimeCN`,
					props: {
						suggest: {
							typeIncludes: `dragRacingElapsedTimeCN`
						},
						createOptions: {
							type: `dragRacingElapsedTimeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否有参加受禁制组织的比赛？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceUnderSanctioningBodyCN`,
					props: {
						suggest: {
							typeIncludes: `isRaceUnderSanctioningBodyCN`
						},
						createOptions: {
							type: `isRaceUnderSanctioningBodyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0raceUnderSanctioningBodyDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `raceUnderSanctioningBodyDetailsCN`
						},
						createOptions: {
							type: `raceUnderSanctioningBodyDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "过去 12 个月的比赛次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfRacesLast12MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `numOfRacesLast12MonthsCN`
						},
						createOptions: {
							type: `numOfRacesLast12MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "过去 12 至 24 个月的比赛次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfRacesLast12to24MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `numOfRacesLast12to24MonthsCN`
						},
						createOptions: {
							type: `numOfRacesLast12to24MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "未来 12 个月的比赛次数",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfRacesNext12MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `numOfRacesNext12MonthsCN`
						},
						createOptions: {
							type: `numOfRacesNext12MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "最高速度",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0maxRaceSpeedAttainedCN`,
					props: {
						suggest: {
							typeIncludes: `maxRaceSpeedAttainedCN`
						},
						createOptions: {
							type: `maxRaceSpeedAttainedCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "平均速度",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageRaceSpeedAttainedCN`,
					props: {
						suggest: {
							typeIncludes: `averageRaceSpeedAttainedCN`
						},
						createOptions: {
							type: `averageRaceSpeedAttainedCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "提供所使用的赛道及路面详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0raceTrackDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `raceTrackDetailsCN`
						},
						createOptions: {
							type: `raceTrackDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否曾进行或试图任何特技驾驶？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTriedStuntDrivingCN`,
					props: {
						suggest: {
							typeIncludes: `hasTriedStuntDrivingCN`
						},
						createOptions: {
							type: `hasTriedStuntDrivingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0stuntDrivingDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `stuntDrivingDetailsCN`
						},
						createOptions: {
							type: `stuntDrivingDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否曾遇到与驾驶有关的意外？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDrivingAccidentCN`,
					props: {
						suggest: {
							typeIncludes: `hasDrivingAccidentCN`
						},
						createOptions: {
							type: `hasDrivingAccidentCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingAccidentDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `drivingAccidentDetailsCN`
						},
						createOptions: {
							type: `drivingAccidentDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaVehicle() {
			return [
				{
					label: "汽车",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceVehicleAutomobileCN`,
					props: {
						suggest: {
							typeIncludes: `isRaceVehicleAutomobileCN`
						},
						createOptions: {
							type: `isRaceVehicleAutomobileCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "电单车",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceVehicleMotorcycleCN`,
					props: {
						suggest: {
							typeIncludes: `isRaceVehicleMotorcycleCN`
						},
						createOptions: {
							type: `isRaceVehicleMotorcycleCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "赛艇",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isRaceVehiclePowerBoatCN`,
					props: {
						suggest: {
							typeIncludes: `isRaceVehiclePowerBoatCN`
						},
						createOptions: {
							type: `isRaceVehiclePowerBoatCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0raceVehicleDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `raceVehicleDetailsCN`
						},
						createOptions: {
							type: `raceVehicleDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: "职业",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0racePurposeProfessionalCN`,
					props: {
						suggest: {
							typeIncludes: `racePurposeProfessionalCN`
						},
						createOptions: {
							type: `racePurposeProfessionalCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "业余爱好",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0racePurposeAmateurCN`,
					props: {
						suggest: {
							typeIncludes: `racePurposeAmateurCN`
						},
						createOptions: {
							type: `racePurposeAmateurCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0racePurposeDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `racePurposeDetailsCN`
						},
						createOptions: {
							type: `racePurposeDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
